import round from "~/helpers/number/round";
import kgToLbs from "~/helpers/units/kgToLbs";

export const convertWeight = (weight: number, useMetric: boolean) => {
  return useMetric ? round(weight, 1) ?? 0 : kgToLbs(weight ?? 0) ?? 0;
};
